function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useCleanupTasksCount } from '@arc/frontend/util-arc-cleanup';
import { DisplayArcGroupImportSuccess, useQueryArcGroupImport } from '@arc/frontend/util-arc-roles';
import { useAbility } from '@arc/frontend/util-auth';
import { isNotNullish } from '@arc/shared/util-js';
import { NavItem } from './NavItem';
const styles = {
  truncatedList: process.env.NODE_ENV === "production" ? {
    name: "89l0mr",
    styles: "display:flex;align-items:stretch;flex-grow:1;& > li:not([hidden]){display:flex;}"
  } : {
    name: "icix5-truncatedList",
    styles: "display:flex;align-items:stretch;flex-grow:1;& > li:not([hidden]){display:flex;};label:truncatedList;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }
};
export function HeaderItems({
  iconButtonStyle: _iconButtonStyle
}) {
  const {
    t
  } = useTranslation(['common', 'permissions', 'deployments']);
  const {
    ability,
    missingPermissionText
  } = useAbility();

  // Get cleanup tasks count for badge
  const {
    data: cleanupTasksCount = 0
  } = useCleanupTasksCount(ability.can('list', 'Job'));
  const {
    data: arcGroupImport
  } = useQueryArcGroupImport();
  const arcGroupImportNew = arcGroupImport?.newGroups ?? [];
  const navItems = useMemo(() => [{
    to: '/members',
    disabled: ability.cannot('view', 'Member'),
    disabledCalloutText: missingPermissionText('view', 'Member'),
    children: t('sections.members')
  }, {
    to: '/builds',
    disabled: ability.cannot('view', 'Build'),
    disabledCalloutText: missingPermissionText('view', 'Build'),
    children: t('sections.builds')
  }, {
    to: '/deployments',
    disabled: ability.cannot('view', 'Deployment'),
    disabledCalloutText: missingPermissionText('view', 'Deployment'),
    children: t('sections.deployments')
  }, {
    to: '/arc-roles',
    disabled: ability.cannot('list', 'ArcRole'),
    disabledCalloutText: missingPermissionText('list', 'ArcRole'),
    children: t('sections.arcRoles'),
    badge: arcGroupImportNew.length ? {
      count: arcGroupImportNew.length,
      color: 'warning'
    } : undefined,
    calloutText: arcGroupImportNew.length ? <DisplayArcGroupImportSuccess import={arcGroupImport} t={t} /> : undefined
  }, {
    to: '/jobs',
    disabled: ability.cannot('list', 'Job'),
    disabledCalloutText: missingPermissionText('list', 'Job'),
    children: t('sections.jobs'),
    end: true
  }, {
    to: '/audit-logs',
    disabled: ability.cannot('list', 'AuditLog'),
    disabledCalloutText: missingPermissionText('list', 'AuditLog'),
    children: t('sections.auditLogs')
  }, {
    to: '/cleanup',
    disabled: ability.cannot('list', 'Job'),
    // Using same permission as jobs for now
    disabledCalloutText: missingPermissionText('list', 'Job'),
    children: t('sections.cleanup'),
    end: true,
    badge: cleanupTasksCount > 0 ? {
      count: cleanupTasksCount,
      color: 'warning'
    } : undefined,
    calloutText: cleanupTasksCount > 0 ? t('common:cleanupResourcesScheduled', {
      count: cleanupTasksCount
    }) : undefined
  }].filter(isNotNullish), [ability, missingPermissionText, t, arcGroupImportNew.length, arcGroupImport, cleanupTasksCount]);
  return <div css={styles.truncatedList}>
			{navItems.map(item => <NavItem {...item} key={typeof item.to === 'string' ? item.to : JSON.stringify(item.to)} />)}
		</div>;
}